import React from 'react';
import PropTypes from 'prop-types';
import {Box, Typography, useMediaQuery, useTheme} from "@mui/material";
import {HelperIconInfo} from "../../../index";
import useStyles from "./RailFlyPageTitleStyles";
import {t} from 'ttag';

const RailFlyPageTitle = ({title = null, HelperIconInfoProps = {}}) => {

    const {breakpoints} = useTheme();
    const isMobile = useMediaQuery(breakpoints.down('sm'));
    const classes = useStyles(isMobile);

    return (
        <Box display={'flex'} flexDirection={'row'}>
            <Typography className={classes.title} variant={'h6'} color={'primary'} display={'inline'}>
                {title}
            </Typography>
            {!isMobile && (
                <HelperIconInfo
                    placement={'right'}
                    title={t`You can travel easily from any station in Germany to or from Frankfurt Airport with Rail&Fly.`}
                    iconButtonProps={{
                        style: {opacity: '.5'}
                    }}
                    {...HelperIconInfoProps}
                />
            )}
        </Box>
    );
};

RailFlyPageTitle.propTypes = {
    title: PropTypes.node,
    HelperIconInfoProps: PropTypes.shape({
        title: PropTypes.any,
        subtitle: PropTypes.any,
        heading: PropTypes.any,
        children: PropTypes.any,
        placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
        color: PropTypes.string,
        backgroundColor: PropTypes.string,
        icon: PropTypes.node,
        iconButtonProps: PropTypes.object,
        popperMessageProps: PropTypes.object,
        popperProps: PropTypes.object,
        arrowProps: PropTypes.object,
    }),
};

export default RailFlyPageTitle;